import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-accstatus-dialog',
  templateUrl: './change-accstatus-dialog.component.html',
  styleUrls: ['./change-accstatus-dialog.component.css']
})
export class ChangeAccstatusDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_status: string;
  statusTo: string;
  disableConfirmbtn = false;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    this.acc_status = this.data.status;
    if (this.acc_status === 'ACTIVE') {
      this.statusTo = 'INACTIVE';
    } else {
      this.statusTo = 'ACTIVE';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.changeStatusAccount(this.data.id)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
